import { ComponentProps } from 'react';

import { cn } from '../lib';

/**
 * -----------------------------------------------------------------------------
 * This renders the base building block for a text area themed as per app standards.
 * See also the `ui/textarea` using headless tailwindcss primitives.
 */
function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        `border-input placeholder:text-muted-foreground focus-visible:border-ring
        focus-visible:ring-ring/50 aria-invalid:ring-destructive/20
        dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive
        dark:bg-input/30 field-sizing-content min-h-16 shadow-xs flex w-full
        rounded-md border bg-transparent px-3 py-2 text-base outline-none
        transition-[color,box-shadow] focus-visible:ring-[3px]
        disabled:cursor-not-allowed disabled:opacity-50 md:text-sm`,
        className
      )}
      data-slot="textarea"
      {...props}
    />
  );
}

export { Textarea };
